// js
import {APP_THEME, BIOMETRIC} from './constants';

// action
export const updateAppTheme = (mode: 'light' | 'dark') => (dispatch: any) => {
  dispatch({
    type: APP_THEME,
    payload: mode,
  });
};

export const updateBiometric = (biometric: boolean) => (dispatch: any) => {
  dispatch({
    type: BIOMETRIC,
    payload: biometric,
  });
};
